import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';

import {
  Heading,
  BaseText,
  ButtonPrimary,
  ButtonSecondary,
  ButtonContainer,
  ButtonIconContextual,
  Modal,
  ChipStatus
} from '@warrenbrasil/nebraska-web';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { addressDocumentUpload } from '../../services/account-bff/api';
import {
  trackRedoAddressDocument,
  trackSendAddressDocument,
  trackPageView
} from './helpers/track-events';

import { validateFile } from './helpers/validate';

interface Props {
  customerId: string;
  isOpen: boolean;
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'on-success'): void;
  (event: 'on-error', value: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressDocumentModalUpload',
  props: {
    customerId: null,
    isOpen: { type: Boolean }
  },
  emits: ["close", "on-success", "on-error"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
  (event: 'on-success'): void;
  (event: 'on-error', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  customerId: string;
  isOpen: boolean;
}

const MAX_SIZE = 1000000 * 10;




const fileName = ref<string>('');
const isPdfFile = ref<boolean>(false);
const formData = ref<FormData | undefined>(undefined);
const isLoading = ref<boolean>(false);
const imagePreview = ref<string>(
  require('./assets/address-document-upload-preview.svg')
);
const fileInput = ref<HTMLInputElement | null>(null);
const file = ref<File>();

onMounted(() => trackPageView());

const handleCloseModal = () => {
  emit('close');
};

const openFileSelector = () => {
  fileInput.value?.click();
};

const setFileDataAndImagePreview = (file: File) => {
  imagePreview.value = URL.createObjectURL(file);
  isPdfFile.value = file.type === 'application/pdf';
  fileName.value = file.name;
};

const checkRedoFile = () => {
  if (fileName.value) trackRedoAddressDocument();
};

const createFormData = (file: File) => {
  formData.value = new FormData();
  formData.value.append('customerId', props.customerId);
  formData.value.append('file', file);
};

const onSelectFile = (): void => {
  const inputFiles = fileInput.value?.files || [];
  file.value = inputFiles[0];
  const errorMessage = validateFile(file.value, MAX_SIZE);
  if (errorMessage) {
    emit('on-error', errorMessage);
    return;
  }
  checkRedoFile();
  setFileDataAndImagePreview(file.value);
  createFormData(file.value);
};

const sendFile = async () => {
  trackSendAddressDocument();
  isLoading.value = true;
  try {
    await addressDocumentUpload(formData.value);
    emit('on-success');
  } catch (error) {
    const errorMessage: string = error.error.message.formatted;
    emit('on-error', errorMessage);
  } finally {
    isLoading.value = false;
  }
};

return { __sfc: true,MAX_SIZE, props, emit, fileName, isPdfFile, formData, isLoading, imagePreview, fileInput, file, handleCloseModal, openFileSelector, setFileDataAndImagePreview, checkRedoFile, createFormData, onSelectFile, sendFile, Heading, BaseText, ButtonPrimary, ButtonSecondary, ButtonContainer, ButtonIconContextual, Modal, ChipStatus, NebraskaColors }
}

})